// extracted by mini-css-extract-plugin
export default {"Separator":"Separator_Separator__C4P0w","Wrapper":"Separator_Wrapper__kge06"};